import React, { useEffect, useState } from 'react';
import BOLayout from '@/pages/back-office/BOLayout';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Modal from '@/components/Modal';
import TableHeaders from '@/components/back-office/users/tables/TableHeaders';
import TableRows from '@/components/back-office/users/tables/TableRows';
import Pagination from '@/components/back-office/Pagination';
import { CSVLink } from 'react-csv';
import BONavigationButton from '@/components/back-office/BONavigationButton';

const BOCustomers = () => {
	const [users, setUsers] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [userEmail, setUserEmail] = useState(null);
	const email = JSON.parse(localStorage.getItem('user'))?.email;
	const role = JSON.parse(localStorage.getItem('role'));
	const navigate = useNavigate();

	const [currentPage, setCurrentPage] = useState(1);
	const usersPerPage = 10;

	useEffect(() => {
		if (role && role !== 'super-admin') {
			toast.info('Zone interdite', {
				position: 'top-center',
				autoClose: 1000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});

			navigate('/back-office');

			return;
		}
	}, [role]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/back-office/settings/users/list`, {
					params: {
						email: email,
						//showRole: 'user',
					},
				});

				if (response.status === 200) {
					console.log(response.data);
					setUsers(response.data);
				}
			} catch (error) {
				console.error('Error fetching users:', error);
				toast.error('Une erreur est survenue', {
					position: 'top-center',
					autoClose: 3500,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					theme: 'colored',
				});
			}
		};

		fetchData();
	}, []);

	const csvHeaders = [
		{ label: 'Prénom', key: 'firstname' },
		{ label: 'Nom', key: 'lastname' },
		{ label: 'Téléphone', key: 'phone_number' },
		{ label: 'Email', key: 'email' },
		{ label: 'Montant total', key: 'total_amount' }
	];

	// Pagination
	const indexOfLastUser = currentPage * usersPerPage;
	const indexOfFirstUser = indexOfLastUser - usersPerPage;
	const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);

	const onPageChange = (pageNumber) => setCurrentPage(pageNumber);

	return (
		<BOLayout>
			<div className="mb-4 grid grid-cols-1 gap-12">
				<div className="mb-12">
					<div className="flex justify-center gap-4">
						<BONavigationButton
							navigationRoute={`#`}
							text={'Importer'}
						/>
						<CSVLink
							data={users}
							headers={csvHeaders}
							filename="clients.csv"
							className="transition duration-300 bg-primary hover:bg-primary/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary/70 text-white px-4 py-2 rounded-lg"
						>
							Exporter
						</CSVLink>
					</div>
				</div>
				<h1 className="text-3xl font-bold text-center">Liste des Clients</h1>
			</div>

			{showModal && (
				<Modal
					type={'danger'}
					title={'Cette action est irréversible'}
					setShowModal={setShowModal}
					handleSubmit={handleModalSubmit}
				/>
			)}

			<table className="table table-striped table-bordered table-fixed w-full text-center">
				<thead className="border-b border-b-black pb-2 mb-4">
					<TableHeaders headers={['Nom', 'Téléphone', 'Email', 'Montant dépensé']} />
				</thead>
				<tbody>
					<TableRows
						rows={currentUsers}
						setShowModal={setShowModal}
						setUserEmail={setUserEmail}
						showAmount={true}
						showActionButtons={false}
					/>
				</tbody>
			</table>

			<Pagination
				currentPage={currentPage}
				totalItems={users.length}
				itemsPerPage={usersPerPage}
				onPageChange={onPageChange}
			/>

			{users.length === 0 && <div className="flex justify-center">Aucun client trouvé</div>}
		</BOLayout>
	);
};

export default BOCustomers;